module.exports = __webpack_public_path__ + "img/sazito.1509a874.png";